type Props = { size?: number; color?: string };

export function IconPlay({ size = 22, color = "currentColor" }: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill={color}
			aria-hidden="true"
		>
			<path d="M8 5v14l11-7z" />
		</svg>
	);
}
